import React, { useEffect, useState } from 'react';
import { SCHOOL_JOKES } from '../data/humor';
import HumorCarousel from './HumorCarousel';
import PersonalHumorTile from './PersonalHumorTile';

const FAVORITES_KEY = 'feriencountdown:favorite-jokes';
const BLOSSOMS_KEY = 'feriencountdown:daily-blossoms';
const RATINGS_KEY = 'feriencountdown:humor-ratings';
const SHARED_KEY = 'feriencountdown:shared-humor';

const DEFAULT_FAVORITE = {
  id: 'favorite-default-fee',
  title: SCHOOL_JOKES[0].title,
  text: SCHOOL_JOKES[0].text,
  createdAt: '1970-01-01T00:00:00.000Z',
  isDefault: true
};

function readStorage(key, fallback) {
  try {
    return JSON.parse(localStorage.getItem(key)) || fallback;
  } catch {
    return fallback;
  }
}

function getSharedKey(entry) {
  return entry.id || `joke:${entry.title}`;
}

function HumorSection() {
  const [favorites, setFavorites] = useState(
    () => readStorage(FAVORITES_KEY, [])
  );
  const [blossoms, setBlossoms] = useState(
    () => readStorage(BLOSSOMS_KEY, [])
  );
  const [ratings, setRatings] = useState(
    () => readStorage(RATINGS_KEY, {})
  );
  const [shared, setShared] = useState(
    () => readStorage(SHARED_KEY, [])
  );

  useEffect(() => {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
  }, [favorites]);

  useEffect(() => {
    localStorage.setItem(BLOSSOMS_KEY, JSON.stringify(blossoms));
  }, [blossoms]);

  useEffect(() => {
    localStorage.setItem(RATINGS_KEY, JSON.stringify(ratings));
  }, [ratings]);

  useEffect(() => {
    localStorage.setItem(SHARED_KEY, JSON.stringify(shared));
  }, [shared]);

  const rateHumor = (id, rating) => {
    setRatings((current) => {
      const next = { ...current };

      if (rating) {
        next[id] = rating;
      } else {
        delete next[id];
      }

      return next;
    });
  };

  const toggleShared = (entry) => {
    const key = getSharedKey(entry);

    setShared((current) => {
      if (current.some((item) => item.key === key)) {
        return current.filter((item) => item.key !== key);
      }

      return [
        ...current,
        {
          key,
          title: entry.title,
          text: entry.text,
          sharedAt: Date.now()
        }
      ];
    });
  };

  const isShared = (entry) => (
    shared.some((item) => item.key === getSharedKey(entry))
  );

  return (
    <section className="humor-section" aria-labelledby="humor-title">
      <div className="section-heading">
        <div>
          <p className="section-kicker">Ein Lächeln zwischendurch</p>
          <h2 id="humor-title">Humor</h2>
        </div>
        <p>Automatischer Wechsel alle 10 Sekunden</p>
      </div>

      <HumorCarousel
        jokes={SCHOOL_JOKES}
        ratings={ratings}
        onRate={rateHumor}
        onShare={toggleShared}
        isShared={isShared}
      />

      <div className="personal-humor-row">
        <div className="personal-row-heading">
          <p className="section-kicker">Deine Sammlung</p>
          <h3>Mein Lieblingswitz</h3>
        </div>

        <PersonalHumorTile
          type="favorite"
          pinnedEntry={DEFAULT_FAVORITE}
          entries={favorites}
          ratings={ratings}
          onSave={(entry) => setFavorites((current) => [entry, ...current])}
          onDelete={(id) => setFavorites(
            (current) => current.filter((entry) => entry.id !== id)
          )}
          onRate={rateHumor}
          onShare={toggleShared}
          isShared={isShared}
        />
      </div>

      <div className="personal-humor-row">
        <div className="personal-row-heading">
          <p className="section-kicker">Der schönste Moment des Tages</p>
          <h3>Stilblüte des Tages</h3>
        </div>

        <PersonalHumorTile
          type="blossom"
          entries={blossoms}
          ratings={ratings}
          onSave={(entry) => setBlossoms((current) => [entry, ...current])}
          onDelete={(id) => setBlossoms(
            (current) => current.filter((entry) => entry.id !== id)
          )}
          onRate={rateHumor}
          onShare={toggleShared}
          isShared={isShared}
        />
      </div>

      {shared.length > 0 && (
        <p className="shared-humor-note">
          {shared.length} Eintrag{shared.length === 1 ? '' : 'e'} für eine
          spätere Freigabe vorgemerkt.
        </p>
      )}
    </section>
  );
}

export default HumorSection;